<template>
        <div class="flex flex-wrap">
            <div class="w-full md:w-3/4 md:pr-20">
                <form method="POST" v-if="!saving">

                    <div class="mb-12">
                        <label for="title" ref="title">
                            Resource Title <span class="text-red">*</span>
                            <div class="text-sm font-sans-book">50 character maximum (including spaces).</div>
                        </label>
                        <input id="title" type="text" name="title"
                            v-validate="'required|max:50'"
                            v-model="form.title">
                            <div class="text-sm font-sans-italic text-gray-dark mt-1">Character count: {{ characterCount }}</div>
                            <span v-show="errors.has('title')" class="error text-error-red text-lg">{{ errors.first('title') }}</span>
                    </div>

                    <div class="mb-12">
                        <button class="button"
                            @click.stop.prevent="saveResource" v-if="!saving">Save</button>
                            <span v-else>Saving...</span>
                    </div>
                </form>
                <div class="text-2xl text-center mb-4" v-else>Saving Resource...</div>
            </div>

        </div>
</template>

<script>
    import messaging from "../../../mixins/messaging";
    import validation from "../../../mixins/validation";
    import {analyticsDataLayer} from "../../../api/analyticsDataLayer";

    export default {
        name: "ResourceCreate",
        mixins: [messaging, validation],
        props: {},
        components: {},
        data: () => ({
            form: {
                title: ""
            },
            saving: false
        }),
        computed: {
            characterCount() {
                return this.form.title ? this.form.title.length : 0;
            }
        },
        watch: {},
        methods: {
            saveResource() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.gotoFirstValidationError();
                        return;
                    }

                    this.saving = true;

                    axios
                        .post(this.$laroute.route("api.resources.store"), this.form)
                        .then(response => {
                            const resource = response.data.data;
                            this.$toasted.show("Resource has been created");
                            this.$store.dispatch("setActiveResource", {
                                data: resource
                            });

                            analyticsDataLayer.emit('resource_created');
                            this.$router.push(`/resources/${resource.id}/basics`);
                            this.saving = false;
                        })
                        .catch(error => {
                            console.log(error);
                            this.displayError(error);
                        });
                });
            }
        },
        mounted() {}
    };
</script>
